

export const linear_v: any = { container: true, direction: "column", width: "100%", height: "100%", flexWrap: 'initial' };
export const linear_h: any = { container: true, direction: "row", width: "100%", height: "100%", flexWrap: 'initial' };


export const linear_item_style: any = { minHeight: '0', minWidth: '0', overflowX: 'hidden', overflowY: 'hidden' };
export const linear_item: any = { item: true, style: linear_item_style };

export const linear_content_style: any = { height: "100%", width: "100%", minHeight: '0', minWidth: '0', overflowY: 'auto', overflowX: 'auto' };
